import React from 'react';
import { Check } from 'lucide-react';
export function ReviewsSection() {
  const benefits = ['Cuts Prep Time in Half', 'Super Easy to Use', 'Perfect for Apples & Potatoes', 'Safe & Hands-Free', 'Great for Daily Meals', 'Makes Cooking Faster & Fun'];
  const reviews = [{
    image: 'https://cdn.magicpatterns.com/uploads/vvcZQCRwR5bwtDRycos9Qe/image.png',
    rating: 5,
    text: 'I use this every morning for apples—it peels them perfectly in seconds. No more mess or wasted time. My kids love their apple snacks now.',
    name: 'Michael T.',
    verified: true
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/6DvPVLTbkjiMBgdDgdw2jt/image.png',
    rating: 5,
    text: 'Great for meal prep! I made mashed potatoes for the family, and this saved me at least 20 minutes of peeling by hand. Highly recommend.',
    name: 'Sarah J.',
    verified: true
  }];
  return <div className="w-full max-w-[1400px] mt-12 px-4" data-id="element-233">
      {/* Benefits Badges */}
      <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-234">
        {benefits.map((benefit, index) => <div key={index} className="bg-blue-900 text-white px-6 py-3 rounded-full flex items-center gap-2 font-semibold text-sm" data-id="element-235">
            {benefit}
            <Check className="w-5 h-5" strokeWidth={3} data-id="element-236" />
          </div>)}
      </div>

      {/* Customer Reviews */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-237">
        {reviews.map((review, index) => <div key={index} className="bg-gray-100 rounded-2xl p-6 flex gap-4" data-id="element-238">
            {/* Review Image */}
            <div className="flex-shrink-0 w-32 h-32 rounded-xl overflow-hidden bg-gray-200" data-id="element-239">
              <img src={review.image} alt="Product in use" className="w-full h-full object-cover" data-id="element-240" />
            </div>

            {/* Review Content */}
            <div className="flex-1 flex flex-col" data-id="element-241">
              {/* Star Rating */}
              <div className="flex gap-1 mb-2" data-id="element-242">
                {[...Array(review.rating)].map((_, i) => <span key={i} className="text-yellow-500 text-lg" data-id="element-243">
                    ⭐
                  </span>)}
              </div>

              {/* Review Text */}
              <p className="text-gray-800 text-sm leading-relaxed mb-3 flex-1" data-id="element-244">
                {review.text}
              </p>

              {/* Reviewer Info */}
              <div className="flex items-center gap-2" data-id="element-245">
                <span className="font-bold text-black" data-id="element-246">{review.name}</span>
                {review.verified && <div className="flex items-center gap-1 text-green-600 text-xs" data-id="element-247">
                    <Check className="w-3 h-3" data-id="element-248" />
                    <span data-id="element-249">Verified purchase</span>
                  </div>}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}